// const serverAddress = process.env.SERVERADDRESS || "http://localhost:5000";
const serverAddress = "https://bookeat.onrender.com";
export default serverAddress;
